import 'prismjs/themes/prism.css';

// Clean up the service worker previously registered by gatsby-plugin-offline (removed).
// Without this, browsers that already installed it keep serving stale cached
// page-data/JS chunks after every redeploy until they unregister it themselves.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
  }
}
